import { getRange } from '../helpers/helpers';

export const scrollTo = (element) => window.scrollTo ({
    behavior: 'smooth',
    left: 0,
    top: element.offsetTop
});

document.querySelector('#anchor').addEventListener('click', () => {
  scrollTo(getRange);
});
